/*
  lp.js — behaviour for the lp-* landing page sections.
  Loaded by layout/theme.liquid only when template.suffix starts with "lp-".

  Add to cart follows snippets/v8-cart.liquid: one delegated handler for
  [data-lp-atc], a POST to /cart/add.js with sections:'cart-section', then the
  cart-widget.js helpers when they exist (UpCart intercepts the request and
  opens its drawer). The international-fees acknowledgement mirrors
  assets/bundle-v2.js: the same CloudFront probe, shown as a dialog instead of
  an inline checkbox so it works from any card.

  A card whose product is already in the cart says "Added to cart" and keeps
  saying it (Adam, 15 Oct: you could add the same thing twice without seeing
  it was added). It follows the cart, not a timer: /cart.js on load and again
  after any cart request finishes (UpCart's public cart events too), so
  removing the line in the drawer puts the button back. Pressing an added
  button opens the drawer instead of adding another.
*/
(function () {
  'use strict';
  if (window.lpReady) return;
  window.lpReady = true;

  /* ------------------------------------------------------------------ */
  /* Add to cart                                                         */
  /* ------------------------------------------------------------------ */
  var busy = false;
  var country = { checked: false, isUS: true, accepted: false };

  try { country.accepted = sessionStorage.getItem('lpTermsAccepted') === '1'; } catch (e) { /* storage blocked */ }

  function probeCountry() {
    if (country.checked) return;
    country.checked = true;
    fetch('https://d43or1ujf2spv.cloudfront.net', { method: 'get' }).then(function (response) {
      if (response.status === 403) country.isUS = false;
    }).catch(function () { /* treated as US, same as the theme */ });
  }

  function termsDialog() {
    var existing = document.getElementById('lp-terms');
    if (existing) return existing;
    var tpl = document.querySelector('template[data-lp-terms]');
    var text = tpl ? tpl.getAttribute('data-lp-terms') : 'All international customers are responsible for all fees that may be charged as a result of importing Advanced Trichology products.';
    var error = tpl ? tpl.getAttribute('data-lp-terms-error') : 'You need to agree to the above terms.';
    var agree = (tpl && tpl.getAttribute('data-lp-terms-agree')) || 'I agree';
    var cancel = (tpl && tpl.getAttribute('data-lp-terms-cancel')) || 'Cancel';
    var cont = (tpl && tpl.getAttribute('data-lp-terms-continue')) || 'Continue';
    var dialog = document.createElement('dialog');
    dialog.id = 'lp-terms';
    dialog.className = 'lp-terms';
    dialog.innerHTML =
      '<form method="dialog">' +
        '<p>' + text + '</p>' +
        '<label><input type="checkbox" name="agree"> ' + agree + '</label>' +
        '<div class="lp-terms__error">' + error + '</div>' +
        '<div class="lp-terms__actions">' +
          '<button type="button" class="lp-btn lp-btn--secondary" value="cancel" data-lp-terms-cancel>' + cancel + '</button>' +
          '<button type="button" class="lp-btn lp-btn--primary" data-lp-terms-continue>' + cont + '</button>' +
        '</div>' +
      '</form>';
    document.body.appendChild(dialog);
    return dialog;
  }

  function ensureTerms() {
    if (country.isUS || country.accepted) return Promise.resolve(true);
    return new Promise(function (resolve) {
      var dialog = termsDialog();
      var box = dialog.querySelector('input[name="agree"]');
      var finish = function (ok) {
        dialog.removeEventListener('close', onClose);
        if (dialog.open) dialog.close();
        resolve(ok);
      };
      var onClose = function () { finish(false); };
      dialog.querySelector('[data-lp-terms-cancel]').onclick = function () { finish(false); };
      dialog.querySelector('[data-lp-terms-continue]').onclick = function () {
        if (!box.checked) { dialog.classList.add('has-error'); return; }
        dialog.classList.remove('has-error');
        country.accepted = true;
        try { sessionStorage.setItem('lpTermsAccepted', '1'); } catch (e) { /* ignore */ }
        finish(true);
      };
      dialog.addEventListener('close', onClose);
      if (typeof dialog.showModal === 'function') dialog.showModal(); else finish(window.confirm(text));
    });
  }

  var inCart = {};

  function markAdded() {
    document.querySelectorAll('[data-lp-atc]').forEach(function (button) {
      if (button.classList.contains('is-busy')) return;
      if (!button.getAttribute('data-label')) button.setAttribute('data-label', button.textContent.trim());
      var added = !!inCart[button.getAttribute('data-variant-id')];
      button.classList.toggle('is-added', added);
      button.textContent = added ? (button.getAttribute('data-label-done') || 'Added to cart') : button.getAttribute('data-label');
    });
  }

  function syncCart(cart) {
    if (!cart || !cart.items) return;
    inCart = {};
    cart.items.forEach(function (line) { inCart[String(line.variant_id)] = true; });
    markAdded();
  }

  /* Reads can overlap (a read started before a change can land after one started after it),
     so only the newest read is applied. */
  var cartSeq = 0;
  function loadCart() {
    if (!document.querySelector('[data-lp-atc]')) return;
    var seq = ++cartSeq;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (seq === cartSeq) syncCart(cart); })
      .catch(function () { /* buttons stay as they are */ });
  }

  /* The header's cart icon is what UpCart listens to, and it works before UpCart has started up;
     window.upcartOpenCart() throws until then. */
  function openCart() {
    var trigger = document.querySelector('.upcart-cart-selector, #cart-trigger');
    if (trigger) { trigger.click(); return true; }
    if (typeof window.upcartOpenCart === 'function') {
      try { window.upcartOpenCart(); return true; } catch (e) { /* not ready */ }
    }
    return false;
  }

  ['aftersell-upcart:public-events:cart-loaded', 'aftersell-upcart:public-events:cart-updated'].forEach(function (name) {
    window.addEventListener(name, function (event) { syncCart((event.detail && event.detail.cart) || event.cart); });
  });

  function settle(button, ok) {
    busy = false;
    button.disabled = false;
    button.classList.remove('is-busy');
    if (ok) {
      inCart[button.getAttribute('data-variant-id')] = true;
      markAdded();
    } else if (button.getAttribute('data-label')) {
      button.textContent = button.getAttribute('data-label');
    }
  }

  function addItem(button, item) {
    if (busy || !item.id) return;
    busy = true;
    button.disabled = true;
    if (!button.getAttribute('data-label')) button.setAttribute('data-label', button.textContent.trim());
    button.classList.remove('is-added');
    button.classList.add('is-busy');
    if (button.getAttribute('data-label-busy')) button.textContent = button.getAttribute('data-label-busy');

    var payload = { items: [item], sections: 'cart-section' };
    if (typeof isWholeSale !== 'undefined') payload.attributes = { isWholeSeller: true };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/add responded ' + response.status);
      return response.json();
    }).then(function (body) {
      if (typeof isWholeSale !== 'undefined') { location.reload(); return; }
      settle(button, true);
      try {
        if (typeof vwoAddToCart === 'function') vwoAddToCart();
        if (typeof updateCartData === 'function') updateCartData(body);
        if (typeof updateCartBadge === 'function') updateCartBadge(item.quantity);
        if (typeof addDiscountProduct === 'function') addDiscountProduct();
      } catch (refresh) {
        console.log('[lp] added, but the cart drawer did not refresh:', refresh);
      }
      document.dispatchEvent(new CustomEvent('lp:added', { detail: { item: item, response: body } }));
    }).catch(function (error) {
      settle(button, false);
      console.log(error);
      var tplErr = document.querySelector('template[data-lp-error]');
      window.alert((tplErr && tplErr.getAttribute('data-lp-error')) || 'An error occurred while processing your request. Please try again later.');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lp-atc]');
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    if (button.classList.contains('is-added') && openCart()) return;
    var item = {
      id: parseInt(button.getAttribute('data-variant-id'), 10),
      quantity: parseInt(button.getAttribute('data-quantity') || '1', 10) || 1
    };
    var plan = parseInt(button.getAttribute('data-selling-plan') || '0', 10);
    if (plan) item.selling_plan = plan;
    ensureTerms().then(function (ok) { if (ok) addItem(button, item); });
  });

  if (document.querySelector('[data-lp-atc]')) probeCountry();
  loadCart();
  document.addEventListener('shopify:section:load', function () {
    if (document.querySelector('[data-lp-atc]')) probeCountry();
    loadCart();
  });
  /* The theme's own cart drawer doesn't announce its changes, and it lowers the header count before
     its request has gone through. Every change, though, ends in a request to /cart/add, change, update
     or clear, so the cart is re-read once one of those has finished. The count is still watched for
     browsers without resource timing, and a page restored from the back/forward cache re-reads too. */
  var cartTimer;
  function cartChanged() { clearTimeout(cartTimer); cartTimer = setTimeout(loadCart, 150); }
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        if (list.getEntries().some(function (entry) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(entry.name); })) cartChanged();
      }).observe({ entryTypes: ['resource'] });
    } catch (e) { /* the count watcher below still runs */ }
  }
  var badge = document.querySelector('.cart-count');
  if (badge && 'MutationObserver' in window) {
    new MutationObserver(cartChanged).observe(badge, { childList: true, characterData: true, subtree: true });
  }
  window.addEventListener('pageshow', function (event) { if (event.persisted) loadCart(); });

  /* ------------------------------------------------------------------ */
  /* The theme's header is position:fixed and the sections start at the  */
  /* top of the body, so the first lander section is padded down by the  */
  /* header's real height (the CSS carries a close fallback).            */
  /* ------------------------------------------------------------------ */
  function offsetHeader() {
    var first = document.querySelector('.lp-wrap');
    if (!first) return;
    document.querySelectorAll('.lp-wrap--first').forEach(function (el) { if (el !== first) { el.classList.remove('lp-wrap--first'); el.style.paddingTop = ''; } });
    first.classList.add('lp-wrap--first');
    /* The theme's nav container is translated below the fixed header box and
       carries its own white background, so pad down to its visual bottom edge. */
    var header = document.querySelector('header');
    if (header && getComputedStyle(header).position === 'fixed' && window.scrollY < 5) {
      var hr = header.getBoundingClientRect();
      var container = header.querySelector('.header-container');
      var bottom = hr.height;
      if (container) bottom = Math.max(bottom, container.getBoundingClientRect().bottom - hr.top);
      if (bottom > 20) first.style.paddingTop = Math.round(bottom) + 'px';
    }
  }
  /* Simplified header / hidden announcement bar come from LP Hero settings. The layout sets the body
     classes server-side; this keeps them right when the hero is edited, added or removed in the editor. */
  function syncHeaderFlags() {
    document.body.classList.toggle('lp-header-simple', !!document.querySelector('[data-lp-header-simple]'));
    document.body.classList.toggle('lp-hide-banner', !!document.querySelector('[data-lp-hide-banner]'));
  }
  syncHeaderFlags();
  document.addEventListener('shopify:section:load', syncHeaderFlags);

  /* Header quiz button (LP Hero setting): hidden at the top, shown once the hero's own buttons have
     scrolled above the viewport. Desktop reuses the theme header's button; phones get a compact link
     with the hero's phone label, inserted before the header icons. */
  var ctaIO = null, ctaEl = null;
  function initHeaderCta() {
    if (ctaIO) { ctaIO.disconnect(); ctaIO = null; }
    if (ctaEl) { ctaEl.remove(); ctaEl = null; }
    document.body.classList.remove('lp-cta-ready', 'lp-cta-on');
    var hero = document.querySelector('[data-lp-header-cta]');
    var host = document.querySelector('header .rt-menu');
    if (!hero || !host || !('IntersectionObserver' in window)) return;
    ctaEl = document.createElement('a');
    ctaEl.className = 'lp-header-cta';
    ctaEl.href = hero.getAttribute('data-lp-header-cta-link') || '/pages/quiz';
    ctaEl.textContent = hero.getAttribute('data-lp-header-cta-label') || 'Take the quiz';
    ctaEl.tabIndex = -1;
    ctaEl.setAttribute('aria-hidden', 'true');
    host.insertBefore(ctaEl, host.firstChild);
    document.body.classList.add('lp-cta-ready');
    var trigger = hero.querySelector('.lp-hero__ctas') || hero;
    ctaIO = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      document.body.classList.toggle('lp-cta-on', past);
      ctaEl.tabIndex = past ? 0 : -1;
      ctaEl.setAttribute('aria-hidden', past ? 'false' : 'true');
    });
    ctaIO.observe(trigger);
  }
  initHeaderCta();
  document.addEventListener('shopify:section:load', function () { setTimeout(initHeaderCta, 60); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(function () { syncHeaderFlags(); offsetHeader(); initHeaderCta(); }, 60); });
  offsetHeader();
  var offsetTimer;
  window.addEventListener('resize', function () { clearTimeout(offsetTimer); offsetTimer = setTimeout(offsetHeader, 150); });
  document.addEventListener('shopify:section:load', function () { setTimeout(offsetHeader, 50); });
  /* ------------------------------------------------------------------ */
  /* Marquee: a scroll container that drifts on its own, loops           */
  /* seamlessly, and still swipes, drags and wheels like a normal row.   */
  /* The drift is scrollLeft for whole pixels plus a transform on the    */
  /* track for the rest: scrollLeft alone moved 20px/s as a one-pixel    */
  /* jump every third frame, which phones showed as a stutter (Adam, 15  */
  /* Oct). It also waits for a swipe's momentum to die out before taking */
  /* the row back, rather than resuming on a timer mid-glide.            */
  /* ------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 767px)');

  function gapOf(el) {
    var cs = getComputedStyle(el);
    return parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
  }

  class LPMarquee extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.scroller = this.querySelector('[data-lp-scroller]');
      this.track = this.querySelector('[data-lp-track]');
      if (!this.scroller || !this.track) return;
      this.items = Array.prototype.slice.call(this.track.children).filter(function (el) { return !el.hasAttribute('data-lp-clone'); });
      if (!this.items.length) return;
      this.speed = parseFloat(this.getAttribute('data-speed')) || 40;
      this.finite = this.hasAttribute('data-static');
      this.paused = false; this.hold = 0; this.last = 0; this.setWidth = 0; this.pos = 0; this.lastSet = 0; this.visible = true; this.fling = 0; this.suppressClick = false;
      this.frac = 0; this.userAt = 0;
      this.build();
      this.bind();
      this.start();
      if (this.finite && this.hasAttribute('data-nudge')) this.nudge();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      if (this.io) this.io.disconnect();
      if (this.nudgeIO) this.nudgeIO.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }
    dir() {
      var d = this.getAttribute('data-direction') || 'left';
      if (phone.matches && this.getAttribute('data-direction-mobile')) d = this.getAttribute('data-direction-mobile');
      return d === 'right' ? -1 : 1;
    }
    build() {
      var self = this;
      this.track.querySelectorAll('[data-lp-clone]').forEach(function (c) { c.remove(); });
      var gap = gapOf(this.track), w = 0;
      this.items.forEach(function (el) { w += el.getBoundingClientRect().width + gap; });
      if (this.finite) {
        this.setWidth = 0;
        this.pos = 0;
        this.scroller.scrollLeft = this.lastSet = 0;
        this.updateArrows();
        return;
      }
      this.setWidth = w;
      if (!w) return;
      var sets = Math.max(2, Math.ceil((this.scroller.clientWidth * 2) / w) + 1);
      for (var n = 0; n < sets; n++) {
        this.items.forEach(function (el) {
          var c = el.cloneNode(true);
          c.setAttribute('data-lp-clone', '');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          c.querySelectorAll('a, button').forEach(function (f) { f.tabIndex = -1; });
          self.track.appendChild(c);
        });
      }
      var start = parseFloat(this.getAttribute('data-start')) || 0;
      if (start) {
        var designCard = parseFloat(this.getAttribute('data-card')) || 0;
        var realCard = this.items[0].getBoundingClientRect().width;
        if (designCard && realCard) start = start * realCard / designCard;
      }
      this.pos = this.dir() > 0 ? start : w - start;
      this.setFrac(0);
      this.scroller.scrollLeft = this.lastSet = Math.round(this.pos);
    }
    bind() {
      var self = this;
      if (this.hasAttribute('data-pause-hover')) {
        this.addEventListener('mouseenter', function () { self.paused = true; });
        this.addEventListener('mouseleave', function () { self.paused = false; });
      }
      this.addEventListener('focusin', function () { self.paused = true; });
      this.addEventListener('focusout', function () { self.paused = false; });
      this.scroller.addEventListener('pointerdown', function () { self.hold = Date.now() + 1500; self.foldFrac(); });
      this.scroller.addEventListener('touchstart', function () { self.hold = Date.now() + 2500; self.foldFrac(); }, { passive: true });
      this.scroller.addEventListener('touchmove', function () { self.hold = Date.now() + 2500; }, { passive: true });
      this.scroller.addEventListener('wheel', function () { self.hold = Date.now() + 1500; self.foldFrac(); }, { passive: true });
      this.scroller.addEventListener('scroll', function () {
        if (Math.abs(self.scroller.scrollLeft - self.lastSet) > 1) {
          /* Moved by the visitor (or their fling), not by the drift. */
          self.userAt = Date.now();
          self.setFrac(0);
          self.pos = self.scroller.scrollLeft;
          /* While the visitor is scrolling (fling included), only loop at the physical ends: moving the
             scroll position mid-gesture stops iOS momentum scrolling. The drift wraps the rest invisibly
             once it resumes. */
          self.wrapEnds();
        }
        self.updateArrows();
      }, { passive: true });

      /* Mouse drag to swipe (touch uses the browser's own scrolling). */
      var sc = this.scroller, drag = null;
      sc.querySelectorAll('img').forEach(function (img) { img.draggable = false; });
      sc.addEventListener('dragstart', function (e) { e.preventDefault(); });
      sc.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        drag = { x: e.clientX, left: self.pos, moved: false, t: performance.now(), lastX: e.clientX, vx: 0 };
        self.fling = 0;
        self.hold = Infinity;
        sc.classList.add('is-dragging');
        try { sc.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      });
      sc.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (Math.abs(dx) > 4) drag.moved = true;
        var now = performance.now(), dt = now - drag.t;
        if (dt > 0) { drag.vx = (e.clientX - drag.lastX) / dt; drag.t = now; drag.lastX = e.clientX; }
        var w = self.setWidth, pos = drag.left - dx;
        if (w) {
          if (pos >= w) { pos -= w; drag.left -= w; }
          else if (pos < 0) { pos += w; drag.left += w; }
        }
        self.pos = pos;
        if (self.finite) self.wrap();
        self.lastSet = Math.round(self.pos);
        sc.scrollLeft = self.lastSet;
        e.preventDefault();
      });
      var endDrag = function () {
        if (!drag) return;
        sc.classList.remove('is-dragging');
        if (drag.moved) {
          self.suppressClick = true;
          setTimeout(function () { self.suppressClick = false; }, 60);
          self.fling = -drag.vx * 1000;
        }
        drag = null;
        self.hold = Date.now() + 1500;
      };
      sc.addEventListener('pointerup', endDrag);
      sc.addEventListener('pointercancel', endDrag);
      sc.addEventListener('lostpointercapture', endDrag);
      sc.addEventListener('click', function (e) {
        if (self.suppressClick) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      var step = function (d) {
        var w = self.items[0].getBoundingClientRect().width + gapOf(self.track);
        self.hold = Date.now() + 2000;
        self.scroller.scrollBy({ left: d * w, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };
      var prev = this.querySelector('[data-lp-prev]'), next = this.querySelector('[data-lp-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) { self.visible = entries[0].isIntersecting; }, { rootMargin: '100px' });
        this.io.observe(this);
      }
      var t;
      this.onResize = function () { clearTimeout(t); t = setTimeout(function () { self.build(); }, 150); };
      window.addEventListener('resize', this.onResize);
    }
    start() {
      var self = this;
      if (this.hasAttribute('data-static') || reduceMotion.matches) return;
      var tick = function (now) {
        self.raf = requestAnimationFrame(tick);
        var dt = self.last ? Math.min(now - self.last, 100) : 0;
        self.last = now;
        if (self.fling) {
          self.pos += self.fling * dt / 1000;
          self.fling *= Math.pow(0.9, dt / 16);
          if (Math.abs(self.fling) < 10) self.fling = 0;
          self.wrap();
          if (!self.finite) { self.place(); return; }
          var t2 = Math.round(self.pos);
          if (t2 !== self.scroller.scrollLeft) { self.lastSet = t2; self.scroller.scrollLeft = t2; }
          return;
        }
        if (!self.setWidth || self.paused || !self.visible || Date.now() < self.hold || Date.now() - self.userAt < 900) return;
        self.pos += self.dir() * self.speed * dt / 1000;
        self.wrap();
        self.place();
      };
      this.raf = requestAnimationFrame(tick);
    }
    /* First time the row is mostly in view, slide it a little and back so visitors can see it
       moves, then reveal the arrows. Skipped for reduced motion, when the row doesn't overflow,
       or once the visitor has already dragged, swiped, wheeled or tabbed into it. */
    nudge() {
      var self = this, track = this.track, fired = false, timer = 0;
      var reveal = function () {
        clearTimeout(timer);
        track.classList.remove('is-nudging');
        self.classList.add('is-hinted');
        self.updateArrows();
      };
      if (reduceMotion.matches || !('IntersectionObserver' in window)) { reveal(); return; }
      var cancel = function () { if (!self.classList.contains('is-hinted')) reveal(); };
      this.scroller.addEventListener('pointerdown', cancel);
      this.scroller.addEventListener('wheel', cancel, { passive: true });
      this.scroller.addEventListener('touchstart', cancel, { passive: true });
      this.scroller.addEventListener('keydown', cancel);
      this.nudgeIO = new IntersectionObserver(function (entries) {
        if (fired || !entries[0].isIntersecting) return;
        fired = true;
        self.nudgeIO.disconnect();
        if (self.classList.contains('is-hinted') || self.maxScroll() < 8) { reveal(); return; }
        timer = setTimeout(function () {
          track.addEventListener('animationend', reveal, { once: true });
          track.classList.add('is-nudging');
          timer = setTimeout(reveal, 1600); /* in case animationend never fires */
        }, 300);
      }, { threshold: 0.6 });
      this.nudgeIO.observe(this);
    }
    maxScroll() { return Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth); }
    /* Whole pixels to scrollLeft, the remainder to the track's transform. */
    place() {
      var whole = Math.floor(this.pos);
      if (whole !== this.lastSet) { this.lastSet = whole; this.scroller.scrollLeft = whole; }
      this.setFrac(this.pos - whole);
    }
    setFrac(f) {
      f = Math.round(f * 100) / 100;
      if (f === this.frac || !this.track) return;
      this.frac = f;
      this.track.style.transform = f ? 'translate3d(' + (-f) + 'px, 0, 0)' : '';
    }
    /* Before a finger or the mouse takes over, hand the remainder back to scrollLeft so nothing shifts. */
    foldFrac() {
      if (!this.frac) return;
      var x = Math.round(this.pos);
      this.setFrac(0);
      this.pos = this.lastSet = x;
      this.scroller.scrollLeft = x;
    }
    wrapEnds() {
      var w = this.setWidth;
      if (this.finite || !w) return;
      var max = this.maxScroll(), margin = 40;
      if (this.pos < margin) this.pos += w;
      else if (this.pos > max - margin) this.pos -= w;
      else return;
      this.lastSet = Math.round(this.pos);
      this.scroller.scrollLeft = this.lastSet;
    }
    updateArrows() {
      var prev = this.querySelector('[data-lp-prev]'), next = this.querySelector('[data-lp-next]');
      if (!this.finite || (!prev && !next)) return;
      var max = this.maxScroll(), x = this.scroller.scrollLeft;
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max - 1;
    }
    wrap() {
      var w = this.setWidth;
      if (this.finite) {
        var max = this.maxScroll();
        if (this.pos < 0) { this.pos = 0; this.fling = 0; }
        else if (this.pos > max) { this.pos = max; this.fling = 0; }
        return;
      }
      if (!w) return;
      if (this.pos >= w) this.pos -= w;
      else if (this.pos < 0) this.pos += w;
      else return;
      this.lastSet = Math.floor(this.pos);
      this.scroller.scrollLeft = this.lastSet;
      this.setFrac(this.pos - this.lastSet);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Slider: scroll-snap row with optional arrows.                       */
  /* ------------------------------------------------------------------ */
  class LPSlider extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-lp-track]');
      if (!this.track) return;
      var prev = this.querySelector('[data-lp-prev]'), next = this.querySelector('[data-lp-next]');
      var step = function (d) {
        var first = self.track.children[0];
        var w = first ? first.getBoundingClientRect().width + gapOf(self.track) : 300;
        self.track.scrollBy({ left: d * w, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };
      var update = function () {
        if (prev) prev.disabled = self.track.scrollLeft <= 1;
        if (next) next.disabled = self.track.scrollLeft + self.track.clientWidth >= self.track.scrollWidth - 1;
      };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      this.track.addEventListener('scroll', update, { passive: true });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
      });
      window.addEventListener('resize', update);
      update();
    }
  }

  if (!customElements.get('lp-marquee')) customElements.define('lp-marquee', LPMarquee);
  if (!customElements.get('lp-slider')) customElements.define('lp-slider', LPSlider);
  /* ------------------------------------------------------------------ */
  /* Tabs: ARIA tablist with arrow keys; the theme editor selecting a    */
  /* zone block opens that tab.                                          */
  /* ------------------------------------------------------------------ */
  class LPTabs extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          /* Phones show the zones as an accordion; closing the panel above would pull the tapped
             header upward, so keep it where the finger was. */
          var before = phone.matches ? tab.getBoundingClientRect().top : null;
          self.select(i);
          if (before !== null) {
            var shift = tab.getBoundingClientRect().top - before;
            if (Math.abs(shift) > 1) window.scrollBy(0, shift);
          }
        });
        tab.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + self.tabs.length) % self.tabs.length;
          self.select(n);
          self.tabs[n].focus();
        });
      });
    }
    select(i) {
      this.tabs.forEach(function (t, j) {
        var on = i === j;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (p, j) { p.hidden = i !== j; });
    }
  }
  if (!customElements.get('lp-tabs')) customElements.define('lp-tabs', LPTabs);

  /* ------------------------------------------------------------------ */
  /* In-page links ("See how the plan works" to #science) glide to their */
  /* section and stop with its top just under the fixed header instead   */
  /* of jumping there (Adam, 15 Oct). Lazy images above the target can   */
  /* move it while the page glides, so the stop is checked again once    */
  /* scrolling settles; a visitor who scrolls in the meantime keeps it.  */
  /* ------------------------------------------------------------------ */
  function headerBottom() {
    var header = document.querySelector('header');
    if (!header) return 0;
    var position = getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') return 0;
    var bottom = header.getBoundingClientRect().bottom;
    var container = header.querySelector('.header-container');
    if (container) bottom = Math.max(bottom, container.getBoundingClientRect().bottom);
    return Math.max(0, bottom);
  }

  function glideTo(target) {
    var box = target.closest('.shopify-section') || target;
    var behavior = reduceMotion.matches ? 'auto' : 'smooth';
    var topOf = function () { return Math.max(0, Math.round(box.getBoundingClientRect().top + window.scrollY - headerBottom())); };
    var cancelled = false;
    var cancel = function () { cancelled = true; };
    var events = ['wheel', 'touchstart', 'keydown'];
    events.forEach(function (name) { window.addEventListener(name, cancel, { passive: true }); });
    window.scrollTo({ top: topOf(), behavior: behavior });
    var lastY = -1, still = 0, checks = 0;
    (function settle() {
      if (!cancelled) {
        var y = window.scrollY;
        still = Math.abs(y - lastY) < 1 ? still + 1 : 0;
        lastY = y;
        if (still < 3 && ++checks < 50) { setTimeout(settle, 80); return; }
        var top = topOf();
        if (Math.abs(top - y) > 2) window.scrollTo({ top: top, behavior: behavior });
      }
      events.forEach(function (name) { window.removeEventListener(name, cancel); });
    })();
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('a[href^="#"]');
    if (!link || !link.closest('.lp, .lp-wrap')) return;
    var id = link.getAttribute('href').slice(1);
    var target = id && document.getElementById(decodeURIComponent(id));
    if (!target) return;
    event.preventDefault();
    glideTo(target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest('[role="tab"]') : null;
    var host = tab ? tab.closest('lp-tabs') : null;
    if (host && host.tabs) host.select(host.tabs.indexOf(tab));
  });
}());
